try {
  setTimeout(function () {
    window.__pagefly_helper_store__ &&
      window.__pagefly_helper_store__.subscribe(function (res) {
        // Place your fetch code inside the subscribe function
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: {}, sections: ["cart-drawer", "cart-icon-bubble"] })
        })
          .then((res) => res.json())
          .then((cartData) => {
            document.querySelector("cart-drawer").renderContents(cartData);
            document.querySelector("cart-drawer.drawer").classList.remove("is-empty");
          })
          .catch((error) => {
            console.error("Fetch error:", error);
            // Handle the error as needed
          });
      });
  }, 2500);
} catch (e) {
  console.warn(e);
}
/*
fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ updates: {}, sections: ["cart-drawer", "cart-icon-bubble"] })}).then((res) => res.json()).then((cartData) => { document.querySelector("cart-drawer").renderContents(cartData); document.querySelector("cart-drawer.drawer").classList.remove("is-empty"); });

	          try {
	          setTimeout(function () {
	            window.__pagefly_helper_store__ &&
	              window.__pagefly_helper_store__.subscribe(function (r) {
	   $.getJSON('/?sections= cart-drawer,cart-icon-bubble').then( sections => {
	                        const cartDrawer =document.querySelector('cart-notification') || document.querySelector('cart-drawer')
	                        cartDrawer.classList.remove('is-empty')
	                        r.sections = sections
	                        cartDrawer.renderContents(r)
	                        $('#cart-icon-bubble')[0].click()
	                      })
	
			});
	          }, 2500);
	        } catch (e) {
	          console.warn(e);
	        }
*/